import {useMaterialStorageHistory} from '@domain/material-storage'
import {useUpmPlantContext} from '@hconnect/upm'
import {Moment} from 'moment-timezone'

import {toRecord} from '../../../helpers/utils'
import {getStoragesFromHistory} from '../../../selectors/storages'
import {MomentRange} from '../../../selectors/time'

interface HistoryStoragesWithMaterialQueryParams {
  timeFrame: MomentRange
  date?: Moment
  throwOnError?: boolean
}

export const useHistoryStoragesByIdQuery = ({
  timeFrame: [from, to],
  date,
  throwOnError = true
}: HistoryStoragesWithMaterialQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useMaterialStorageHistory({
    plantId: plantCode,
    from: from.toISOString(),
    to: to.toISOString(),
    options: {
      select: (storagesHistory) => {
        return toRecord(getStoragesFromHistory(storagesHistory, date ?? to), 'id')
      },
      throwOnError
    }
  })
}
